var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"powered-by-controlla",on:{"click":function($event){return _vm.openUrl('http://controlla.com.mx/')}}},[_c('img',{attrs:{"src":require("@/assets/poweredByControlla.svg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }